import axios from "../../utils/axios";

export const getBlogs = async ({ filter, sort }) => {
  let response;

  

  if (sort.type === "most_liked") {
    // filter
    if (filter === "Saved") {
      response = await axios.get(`/blogs?isSaved=true&_sort=likes&_order=desc`);
      return response.data;
    }

    response = await axios.get(`/blogs?_sort=likes&_order=desc`);
    return response.data;
  } else if (sort.type === "newest") {
    // filter
    if (filter === "Saved") {
      response = await axios.get(`/blogs?isSaved=true&_sort=createAts&_order=desc`);
      return response.data;
    }

    response = await axios.get(`/blogs?_sort=createdAt&_order=desc`);
    return response.data;
  }else{
    if(filter === "Saved"){
        response = await axios.get("/blogs?isSaved=true");
        return response.data; 
    }
    response = await axios.get("/blogs");
    return response.data;
  }

  
};
